<template>
  <sc-link
    v-if="fields && fields.link"
    :field="fields.link"
    class="c-footer__icon"
    :class="fields.link.value.class"
    rel="noopener noreferrer"
  />
</template>

<script>
import { Link } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Footer-SocialLink',
  props: {
    fields: {
      type: Object
    },
    rendering: {
      type: Object
    }
  },
  components: {
    ScLink: Link
  }
};
</script>

<style lang="scss">
.c-footer__social {
  display: flex;
  flex-basis: 100%;
  align-items: center;
  margin-top: 4rem;

  @include desktop-up {
    flex-basis: auto;
    margin-top: 0;
  }

  .c-footer__icon {
    background-repeat: no-repeat;
    background-size: contain;
    display: inline-block;
    margin-left: 2.5rem;
    line-height: 0;
    font-size: 0;
    color: transparent;

    &:first-child {
      margin-left: 0;
    }

    span {
      clip-path: inset(100%);
      clip: rect(0.1rem, 0.1rem, 0.1rem, 0.1rem);
      height: 0.1rem;
      overflow: hidden;
      position: absolute;
      white-space: nowrap;
      width: 0.1rem;
    }

    &.twitter {
      width: 2.2rem;
      height: 1.7rem;
      background-image: url(~@/assets/images/logo-twitter.svg);
    }

    &.facebook {
      width: 2.2rem;
      height: 2.1rem;
      background-image: url(~@/assets/images/logo-facebook.svg);
    }

    &.youtube {
      width: 2.6rem;
      height: 1.7rem;
      background-image: url(~@/assets/images/logo-youtube.svg);
    }

    &.linkedin {
      width: 2rem;
      height: 1.7rem;
      background-image: url(~@/assets/images/logo-linkedin.svg);
    }
  }
}

.c-footer__global {
  &.editMode {
    .c-footer__social {
      a {
        color: $white;
      }
    }
  }
}
</style>
